/* global STRIPE_PUBLISHABLE_KEY */

import PropTypes from 'prop-types';
import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  withStyles,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

import Cost from 'common/components/Cost';
import StripeCheckout from 'ondemand/components/StripeCheckout';
import messages from 'ondemand/messages.json';

const styles = () => ({
  root: {
    minWidth: 36,
  },
});

class PaymentModal extends React.Component {

  state = {
    acceptedTerms: false,
  };

  render() {
    const {publishableKey, capacity, existingToken,
      onCash, onClose, onToken, service, tokenTransitPayment, ttneedsAcceptance} = this.props;
    const amount = capacity * service.fare_price;

    const actions = [
      <Button
        data-id="pay-cash"
        key="pay-cash"
        onClick={onCash}
        color="primary"
        variant="text"
      >
        PAY ON VEHICLE
      </Button>
    ];

    const payNowButton = (onPayNowClick) => (
      <Button
        data-id="pay-credit-card"
        key="pay-credit-card"
        onClick={onPayNowClick}
        color="primary"
        variant="text"
      >
        PAY NOW
      </Button>
    );

    const stripeCheckout = (onTokenReturn) => (
      <StripeCheckout
        amount={amount}
        onToken={onTokenReturn}
        publishableKey={publishableKey}
        key="stripe-check-out"
      >
        {payNowButton(() => {})}
      </StripeCheckout>
    );


    if (existingToken) {
      if (tokenTransitPayment && ttneedsAcceptance) {
        actions.push(
          payNowButton(
            () => {
              if (this.state.acceptedTerms) {
                onToken({
                  stripe_token: existingToken,
                  accepted_latest_terms: true,
                });
              }
            }
          ),
        );
      } else {
        actions.push(payNowButton(() => onToken({stripe_token: existingToken})));
      }
    } else {
      actions.push(
        stripeCheckout(
          ({id}) => onToken({stripe_token: id})
        ),
      );
    }

    const title = <div><Cost amount={amount} currencyCode="USD" /> Payment Required</div>;
    return (
      <Dialog title={title} open onClose={onClose}>
        <DialogTitle>{title}</DialogTitle>

        <DialogContent>
          <DialogContentText>

          {messages.paymentOptions}
          {' '}
          <i>{messages.refundPolicy}</i>
          <span style={{position: 'absolute', top: 8, right: 8}}>
            <IconButton
              data-id="close-payment"
              aria-label="Close"
              onClick={onClose}
              classes={{
                root: this.props.classes.root
              }}
            >
              <CloseIcon />
            </IconButton>

          </span>
          {tokenTransitPayment && ttneedsAcceptance &&
            <span style={{paddingTop: 20}}>
              You must accept
              the <a href="https://tokentransit.com/legal/terms" target="_blank" rel="noopener">
              Token Transit Terms of Service</a> and
              {' '}
              <a href="https://www.tokentransit.com/legal/privacy"
                target="_blank"
                rel="noopener"
              >
                Privacy Policy
              </a> to make a credit card purchase.
              <span>
                <FormControl
                  error={tokenTransitPayment && !this.state.acceptedTerms}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={this.state.acceptedTokenTransitTerms}
                        onChange={(event) => this.setState({acceptedTerms: event.target.checked})}
                        color="primary"
                        inputProps={{
                          'aria-label': 'Accept Terms and Conditions',
                        }}
                        data-id="token-transit-terms"
                      />
                    }
                    label="Accept Terms and Conditions"
                  />
                  {tokenTransitPayment && !this.state.acceptedTerms &&
                    <FormHelperText>Terms and conditions must be accepted.</FormHelperText>
                  }
                </FormControl>
              </span>
            </span>
            }

          </DialogContentText>
        </DialogContent>

        <DialogActions>
          {actions}
        </DialogActions>
      </Dialog>
    );
  }
}

PaymentModal.propTypes = {
  existingToken: PropTypes.string,
  capacity: PropTypes.number,
  onCash: PropTypes.func,
  onClose: PropTypes.func,
  onToken: PropTypes.func,
  service: PropTypes.shape({
    fare_price: PropTypes.number,
  }),
  publishableKey: PropTypes.string,
  tokenTransitPayment: PropTypes.bool,
  ttneedsAcceptance: PropTypes.bool,
  classes: PropTypes.object,
};

export default withStyles(styles)(PaymentModal);



// WEBPACK FOOTER //
// ./src/ondemand/components/PaymentModal.js